import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Cookie from '../../services/CookieService';
import { getUserDataAction } from '../../actions/authActions';

const SessionWatcher = () => {

    const dispatch = useDispatch();
    const accessToken = useSelector(state => state.auth.accessToken);

    useEffect(() => {

        const checkSession = () => {
            const cookieToken = Cookie.get(process.env.REACT_APP_COOKIE_NAME);

            // Si cambió el token mientras la aplicación estaba abierta, actualizo en Redux los datos de la sesión actual.
            if (cookieToken && cookieToken !== accessToken) {
                dispatch(getUserDataAction());
            }
        };

        window.addEventListener('focus', checkSession);

        return () => {
            window.removeEventListener('focus', checkSession);
        };

    }, [accessToken, dispatch]);

    return null;
};

export default SessionWatcher;